import { getFilenameFromHeaders, saveFile } from '@/services/helpers';
import { toast } from '@palmetto/palmetto-components';

const GENERIC_ERROR_MESSAGE = 'Error exporting Conga test CSV. Please try again later.';

async function readErrorMessage(response: Response): Promise<string> {
  try {
    const body: unknown = await response.json();
    if (typeof body === 'object' && body !== null && 'message' in body && typeof body.message === 'string') {
      return body.message || GENERIC_ERROR_MESSAGE;
    }
  } catch {
    // Non-JSON error bodies (e.g. proxy pages) fall through to the generic message.
  }
  return GENERIC_ERROR_MESSAGE;
}

/**
 * Plain fetch instead of `downloadFile`, which would save an error response body as the CSV.
 */
export async function exportCongaTestCsv(apiBaseUrl: string, accountId: string, email: string): Promise<void> {
  try {
    const response = await fetch(
      `${apiBaseUrl}/internal/conga-test-export/accounts/${accountId}?email=${encodeURIComponent(email)}`,
    );
    if (!response.ok) {
      toast.error(await readErrorMessage(response));
      return;
    }
    saveFile(await response.blob(), getFilenameFromHeaders(response.headers, `conga-test-${accountId}.csv`));
  } catch (error) {
    console.error('Error exporting Conga test CSV.', error);
    toast.error(GENERIC_ERROR_MESSAGE);
  }
}
